export default "__VITE_ASSET__CDfj$cEj__"